import { useMemo, useState } from "react";
import { useMonthlyReportData } from "../../shared/useMonthlyReportData";
import { buildLeaderboards, TierFilter } from "../utils/buildLeaderboards";

/**
 * Loads the monthly scoreboard extract (same endpoint as the Monthly Report) and
 * reshapes it into per-trade leaderboards. Fetching is on-demand via `run`; the
 * tier filter re-derives the leaderboards client-side without re-fetching.
 */
export const useTradeLeaderboards = () => {
  const [tier, setTier] = useState<TierFilter>("all");
  const { failed, hasRun, loading, meta, rows, run, runNonce } =
    useMonthlyReportData();

  const leaderboards = useMemo(
    () => buildLeaderboards(rows, tier),
    [rows, tier],
  );

  return {
    failed,
    hasRun,
    leaderboards,
    loading,
    meta,
    run,
    runNonce,
    setTier,
    tier,
  };
};
